<template>
  <div>
    <el-dialog
      title="审核"
      :visible.sync="isShow"
      width="550px"
      :close-on-click-modal="false"
      :before-close="dialogBeforeClose"
    >
      <el-form
        ref="auditFormDom"
        hide-required-asterisk
        :model="auditForm"
        :rules="auditFormRules"
        :label-width="'140px'"
      >
        <template v-if="isInClubSystem">
          <el-form-item v-if="isShowScore" label="专家打分">
            <p> {{auditTotalScore?auditTotalScore+'分':'--'}}</p>
            <!-- <el-input-number
              v-model.number="auditForm.auditScore"
              :min="0"
              label="请填写分值"
            ></el-input-number> -->
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item v-if="isShowScore" label="总分数">
            <p> {{auditTotalScore}}分</p>
            <!-- <el-input-number
              v-model.number="auditForm.auditScore"
              :min="0"
              label="请填写分值"
            ></el-input-number> -->
          </el-form-item>
        </template>

        <el-form-item label="备注" prop="auditInfo">
          <el-input
            type="textarea"
            :rows="3"
            class="w350"
            v-model="auditForm.auditInfo"
            :placeholder="placeHolderTips"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="btnStatus === 3" label="是否退回全部指标">
          <el-switch
            v-model="allAmend"
            active-color="#13ce66"
            inactive-color="#ccc"
            @change="handleFormAllAction()"
          ></el-switch>
        </el-form-item>
        <el-form-item v-if="btnStatus === 3 && allAmend === false" label="请选择具体指标项" prop="amend">
          <el-select v-model="auditForm.amend"
            class="w350" multiple clearable placeholder="如需申请方继续完善资料请选择具体指标项">
            <el-option v-for="(item, index ) in selectOptionsForDeny" :key="index" :label="`${index + 1}、${item.label}`" :value="item.value" class="w300"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="footer-btns">
        <el-button type="primary" :loading="addbtnLoading" @click="handleFormAction(1)">通过</el-button>
        <template v-if="!isInClubSystem">
          <el-button type="warning" :loading="addbtnLoading" @click="handleFormAction(3)">继续完善材料</el-button>
        </template>
        <el-button type="danger" :loading="addbtnLoading" @click="handleFormAction(2)">拒绝申请</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { orgAuditLogAdd, loadUnSortYouthList } from "@/api/performance";
import storage from '@/utils/storage'

import mixinAppConfig from "@/mixin/mixinAppConfig";


export default {
  mixins: [mixinAppConfig],
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    stageUuid: {
      type: String,
      required: true,
    },
    youthUuid: {
      type: String,
      required: true,
    },
    selectOptionsForDeny: {
      type: Array,
      required: true,
    },
    auditTotalScore: {
      type: Number,
      required: false,
      default: 0
    },
    maxScore: {
      type: Number,
      required: false,
      default: 0
    },
    isShowScore: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      userRole: storage.get('userInfo').userRole,
      auditForm: {
        auditInfo: "",
        auditScore: "",
        amend: [],
      },
      btnStatus: 1,
      addbtnLoading: false,
      allAmend:false,
      // selectOptionsForDeny: [],
    };
  },

  computed: {
    auditFormRules() {
      return {
        auditInfo: [
          {
            required: !![2, 3].includes(this.btnStatus),
            message: "如审核结果为继续完善材料或拒绝申请，请输入具体原因。",
            trigger: ["blur", "change"],
          },
        ],
        amend: [
          {
            required: !![3].includes(this.btnStatus),
            message: "如需申请方继续完善资料请选择具体指标项",
            trigger: ["blur", "change"],
          },
        ],
      };
    },

    placeHolderTips() {
      const clubConfig = this.$store.getters.sysHostType
      if(clubConfig === 'club') {
         // ★☆
        if(this.userRole === 'admin') {
          return ""
        } else {
          return ""
        }
      } else {
        return `如审核结果为继续完善材料或拒绝申请，请输入具体原因。`
      }


    },
  },

  methods: {
    dialogBeforeClose() {
      this.setDialogStatus(false);
    },

    setDialogStatus(flag) {
      this.$emit("update:isShow", flag);
    },

    handleFormAction(stauts) {
      this.btnStatus = stauts;
//      if(stauts === 3 ) this.handleFormAllAction(); // 默认关闭，点击后进行选择
      this.$nextTick(() => {
        this.$refs["auditFormDom"].validate((valid) => {
          if (valid) {
            this.addbtnLoading = true
            const { auditInfo,amend, auditScore } = this.auditForm;
            const postData = {
              auditInfo,
              amend: JSON.stringify(amend),
              auditState: stauts,
              stageUuid: this.stageUuid,
              youthUuid: this.youthUuid,
               auditScore: this.auditTotalScore,
//              auditScore: auditScore,
            };
            orgAuditLogAdd(postData)
              .then((res) => {
                this.addbtnLoading = false
                if (res.code) {
                  this.$message.error(res.msg);
                  this.$emit('callback', false)
                  return;
                }
                this.setDialogStatus(false)
                this.$message.success("审核完成！");
                this.$emit('callback', true)
              })
              .catch((err) => {
                this.addbtnLoading = false
                this.$emit('callback', false)
                console.error("err", err);
              });
          }
        });
      });
    },

    handleFormAllAction(){
      if(this.allAmend){
        let amendList = [];
        this.selectOptionsForDeny.forEach((item) => {
          amendList.push(item.value);
        });
        this.auditForm.amend = amendList;
      }else{
        this.auditForm.amend = [];
      }
    },

  },
};
</script>

<style lang="stylus" scoped>
.footer-btns
  width 60%
  margin 0 auto
  display flex
  justify-content space-around
.w350
  width 350px
.w300
  width: 340px
/deep/.el-select-dropdown.is-multiple,/deep/.el-select-dropdown__item.selected
  color $color_green
</style>
